module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.9863/img/app-marketplace-network-2x.png"